<template>
  <div class="SlsSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
            @on-change="changeCompanyID"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyIdList"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
          @on-search="searchAccountName()"
        />
      </Col>
      <Col span="6">
        <Input
          v-model="projectName"
          :placeholder="$t('alarms.common.filterByProjectName')"
          @on-search="searchProjectName()"
        />
      </Col>
      <Col span="4">
        <Button
                    v-hasPermission="['resourceConfigurationManagement:ali:sls:page']"
                    @click="getData"
                    >{{ $t("message.select") }}</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil";
import TableSls from "./TableSls";
var tableSls = TableSls;
export default {
  name: "SlsSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountName: "",
      projectName: "",
    };
  },
  mounted: function () {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      // tableSls.methods.showAll();
    }
  },
  methods: {
    getData(){
      eventBus.$emit("projectName", this.projectName);
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountName", this.accountName);
      tableSls.methods.showAll();
    },
    //查询公司
    listRegisterInformation: function () {
      this.$api.user.listRegisterInformation().then((res) => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        this.searchCompany();
      });
    },
    // 切换公司
    changeCompanyID: function () {
      this.searchCompany();
    },
    // 按公司搜索
    searchCompany: function () {
      eventBus.$emit("companyId", this.companyId);
      // tableSls.methods.showAll();
    },
    // 按账户名称查询
    searchAccountName: function () {
      eventBus.$emit("accountName", this.accountName);
      // tableSls.methods.showAll();
    },
    //按项目名称来查询
    searchProjectName: function () {
      eventBus.$emit("projectName", this.projectName);
      // tableSls.methods.showAll();
    },
  },
};
</script>
<style scoped>
.SlsSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/sls/SlsSearch.vue